import settings from "config/config";
import fetchWrapper from "./fetchWrapper";

const createPaymentUrl = settings.backendApiUrl + "/payment/create";

export const postPaymentCreation = (data) => fetchWrapper.postJSONreceiveJSON(createPaymentUrl, data);
